import { PDFDocument } from 'pdf-lib'

export const mergePdfBlobs = async (blobs: Blob[]): Promise<Blob> => {
  if (blobs.length === 1) return blobs[0]
  const merged = await PDFDocument.create()
  for (const blob of blobs) {
    const src = await PDFDocument.load(await blob.arrayBuffer())
    const pages = await merged.copyPages(src, src.getPageIndices())
    pages.forEach(page => merged.addPage(page))
  }
  const bytes = await merged.save()
  return new Blob([bytes as BlobPart], { type: 'application/pdf' })
}
